module.exports = __webpack_public_path__ + "media/images/athletes/1852-09e7f6470ea606dacf5d6619d4c05f9d.png";